import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import moment from "moment";
import InputMask from 'react-input-mask';
import Loader from "../Loader.js";
import Select from "react-select";

import Modal from "react-modal";
import data from "../Home/GetStarted/body.json";  // Import body shape color data

function MyAccount() {
  
  const [profiles, setProfiles] = useState();
  const [loader, setLoader] = useState(false);
  const [DOB, setDOB] = useState("");

  const [editMode, setEditMode] = useState(false);  // New state for edit mode
  
  const [size, setSize] = useState("");
  const [height, setHeight] = useState("");

  //Change the body shape
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [bodyShapeModal, setBodyShapeModal] = useState(false);
  const [selectedBodyShape, setSelectedBodyShape] = useState("");
  const [colorUpdated, setColorUpdated] = useState(false); // Track if the color has been updated
  

  // Initial userData structure
  const initialUserData = {
    first_name: "",
    last_name: "",
    email: "",
    phone_number: "",
    zipcode: "",
    birth_date: "",
    height: "",
    size: "",
    shape_color: "",
    color_updated:Boolean
  };

  const [userData, setUserData] = useState(initialUserData);

  useEffect(() => {
    profileData();  // Fetch profile data on component mount
    window.scrollTo(0, 0);
  }, []);

  // Function to fetch profile data
  const profileData = () => {
    setLoader(true);

    let profileTok = localStorage.getItem("tokenn");


    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/v1/users/get_profile`, {
        headers: {
          Authorization: `Bearer ${profileTok}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        const user = response?.data?.user;  // Get user data from API response
        setProfiles(user);  // Store full profile if needed later
        
        setDOB(moment(user.birth_date).format("MM/DD/YYYY"));  // Format birth date

        // Populate userData with the fetched profile data
        setUserData({
          first_name: user.first_name,
          last_name: user.last_name,
          email: user.email,
          phone_number: user.phone,
          zipcode: user.zip_code,
          birth_date: moment(user.birthday).format("YYYY-MM-DD"),  // For the date input format
          height: user.height,
          size: user.size,
          shape_color: user.shape_color,
          color_updated: user.color_updated
        });

        setSelectedBodyShape(user.shape_color);  // Set initial body shape color
        setColorUpdated(user.color_updated);     // Track if color has already been updated

        setLoader(false);  // Hide the loader
      })
      .catch((error) => {
        setLoader(false);
        console.error("Error fetching profile:", error);
      });
  };

  const handleSave = async (e) => {
    e.preventDefault();

    const token = localStorage.getItem("tokenn");
    try {
      const requestBody = {
        first_name: userData.first_name,
        last_name: userData.last_name,
        email: userData.email,
        phone: userData.phone_number,
        zipcode: userData.zip_code,
        birthday: moment(userData.birth_date).format("YYYY-MM-DD"),  // For the date input format
        height: userData.height,
        size: userData.size,      
        //color_updated: colorUpdated,
        body_shape_color: selectedBodyShape
      };

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/v1/users/update_profile`,
        requestBody,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log("User updated:", response.data);

      setEditMode(false);  // Switch back to read mode
      profileData();       // Fetch updated profile
      

    } catch (error) {
      console.error("Error updating user:", error.response?.data?.detail);
    }
  };

  const sizeOptions = [
    { label: "Regular", value: "Regular" },
    { label: "Plus", value: "Plus" },
  ];

  const heightOptions = [
    { label: "Tall", value: "Tall" },
    { label: "Average", value: "Average" },
    { label: "Petite", value: "Petite" },
  ];

  const handleBodyShapeChange = (shape) => {
    setSelectedBodyShape(shape.color);
    setBodyShapeModal(false);
    setModalIsOpen(false);
    setColorUpdated(true);  // Mark the color as updated
    localStorage.setItem("color", shape.color);
  };


  
  return (
    <div className="my-account-comp">
      <div className="container">
        <div className="heading-getstarted">
          <h6 className="get">MY ACCOUNT</h6>
        </div>


        {/* Edit user information by this */}
        <div className="account-title">
        <h2 className="font-lg-24 mb-5">Personal Information</h2>
        
        {editMode ? (
            <div>
            <form onSubmit={handleSave}>  {/* We'll define handleSave below */}
                <div className="row">
                <div className="col-md-6 col-12 mb-3">
                    <label className="font-weight-bold">First Name</label>
                    <input
                    type="text"
                    className="form-control"
                    value={userData.first_name}
                    onChange={(e) => setUserData({ ...userData, first_name: e.target.value })}
                    />
                </div>

                <div className="col-md-6 col-12 mb-3">
                    <label className="font-weight-bold">Last Name</label>
                    <input
                    type="text"
                    className="form-control"
                    value={userData.last_name}
                    onChange={(e) => setUserData({ ...userData, last_name: e.target.value })}
                    />
                </div>

                <div className="col-md-6 col-12 mb-3">
                    <label className="font-weight-bold">Email</label>
                    <input
                    type="email"
                    className="form-control"
                    value={userData.email}
                    onChange={(e) => setUserData({ ...userData, email: e.target.value })}
                    />
                </div>

                <div className="col-md-6 col-12 mb-3">
                <label className="font-weight-bold">Phone Number</label>
                    <InputMask
                      mask="+1 (999) 999-9999"
                      value={userData.phone_number}
                      onChange={(e) => setUserData({ ...userData, phone_number: e.target.value })}
                    >
                      {(inputProps) => <input {...inputProps} type="text" className="form-control" />}
                    </InputMask>
                </div>

                <div className="col-md-6 col-12 mb-3">
                <label className="font-weight-bold">Zipcode</label>
                    <InputMask
                      mask="99999"
                      value={userData.zipcode}
                      onChange={(e) => setUserData({ ...userData, zipcode: e.target.value })}
                    >
                      {(inputProps) => <input {...inputProps} type="text" className="form-control" />}
                    </InputMask>
                </div>

                <div className="col-md-6 col-12 mb-3">
                    <label className="font-weight-bold">Birth Date</label>
                    <input
                    type="date"
                    className="form-control"
                    value={userData.birth_date}
                    onChange={(e) => setUserData({ ...userData, birth_date: e.target.value })}
                    />
                </div>

                <div className="col-md-6 col-12 mb-3">
                    <label className="font-weight-bold">Height</label>
                    <Select
                      options={heightOptions}
                      value={heightOptions.find(option => option.value === userData.height)}
                      onChange={(selected) => setUserData({ 
                        ...userData, 
                        height: selected ? selected.value : userData.height 
                      })}
                    />
                </div>

                <div className="col-md-6 col-12 mb-3">
                    <label className="font-weight-bold">Size</label>
                    <Select
                      options={sizeOptions}
                      value={sizeOptions.find(option => option.value === userData.size)}
                      onChange={(selected) => setUserData({ 
                        ...userData, 
                        size: selected ? selected.value : userData.size 
                      })}
                    />
                </div>

                

                {/* Conditionally Render Body Shape Color */}
                {colorUpdated ? (
                    <div className="col-md-6 col-12 mb-3">
                      <label className="font-weight-bold">Body Shape Color</label>
                      <p>{selectedBodyShape}</p>
                      <p>You can only change this once. Contact us for further assistance.</p>
                    </div>
                  ) : (
                    <div className="col-md-6 col-12 mb-3">
                      <label className="font-weight-bold">Body Shape Color</label>
                      <div
                        className="bodyshape_change"
                        onClick={() => {
                          setModalIsOpen(true);
                          setBodyShapeModal(true);
                        }}
                      >
                        <u>Change Body Shape</u>
                      </div>
                      <p>Current: {selectedBodyShape}</p>

                      <Modal
                        isOpen={modalIsOpen}
                        onRequestClose={() => {
                          setModalIsOpen(false);
                          setBodyShapeModal(false);
                        }}
                      >
                        <div className="row body_shape">
                          <h5>Select a Body Shape</h5>
                          {data.map((element, key) => (
                            <div
                              key={key}
                              className="col-lg-6"
                              onClick={() => handleBodyShapeChange(element)}
                            >
                              <div className="get-start0card mb-3">
                                <div className="row g-0 align-items-center">
                                  <div className="col-md-6">
                                    <div
                                      className={
                                        element.color === selectedBodyShape
                                          ? "get-start-img selected"
                                          : "get-start-img"
                                      }
                                    >
                                      <img
                                        src={element.image}
                                        className="img-fluid rounded-start"
                                        alt={element.color}
                                      />
                                    </div>
                                  </div>
                                  <div className="col-md-6">
                                    <div className="card-body">
                                      <div className="card-text">

                                        <div dangerouslySetInnerHTML={{ __html: element.list }} /> {/* Fix: Render HTML content */}
                                        
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </Modal>
                    </div>
                  )}
                </div>



                {/* Save and Cancel buttons */}
                <div className="d-flex justify-content-between">
                <button type="submit" className="btn btn-success">Save</button>
                <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setEditMode(false)}  // Cancel edit mode
                >
                    Cancel
                </button>
                </div>
            </form>
            </div>


        ) : (


            // Read User Information
          <div className="account-title">
            <div className="readonly">
              <div className="row">
                <div className="col-md-4 col-6 mb-5">  
                  <div className="fafa-icon-users">
                    <i className="fa fa-user mr-2" aria-hidden="true"></i>
                    <div className="fafa-icon-myaccount">
                      <h6 className="font-weight-bold">First Name</h6>
                      {userData.first_name}
                    </div>
                  </div>
                </div>

                <div className="col-md-4 col-6 mb-5">
                  <div className="fafa-icon-users">
                    <i className="fa fa-user mr-2" aria-hidden="true"></i>
                    <div className="fafa-icon-myaccount">
                      <h6 className="font-weight-bold">Last Name</h6>
                      {userData.last_name}
                    </div>
                  </div>
                </div>
                <div className="col-md-4 col-6 mb-5">
                  <div className="fafa-icon-users">
                    <i className="fa fa-envelope" aria-hidden="true"></i>
                    <div className="fafa-icon-myaccount">
                      <h6 className="font-weight-bold">Email</h6>
                      {userData.email}
                    </div>
                  </div>
                </div>
                <div className="col-md-4 col-6 mb-5">
                  <div className="fafa-icon-users">
                    <i className="fa fa-phone" aria-hidden="true"></i>
                    <div className="fafa-icon-myaccount">
                      <h6 className="font-weight-bold">Phone Number</h6>
                      {userData.phone_number}
                    </div>
                  </div>
                </div>
                <div className="col-md-4 col-6 mb-5">
                  <div className="fafa-icon-users">
                    <i className="fa fa-map-marker" aria-hidden="true"></i>
                    <div className="fafa-icon-myaccount">
                      <h6 className="font-weight-bold">Zipcode</h6>
                      {userData.zipcode}
                    </div>
                  </div>
                </div>
                <div className="col-md-4 col-6 mb-5">
                  <div className="fafa-icon-users">
                    <i className="fa fa-birthday-cake" aria-hidden="true"></i>
                    <div className="fafa-icon-myaccount">
                      <h6 className="font-weight-bold">Birth Date</h6>
                      {DOB}  {/* Display formatted date */}
                    </div>
                  </div>
                </div>
                <div className="col-md-4 col-6 mb-5">
                  <div className="fafa-icon-users">
                    <i className="fa fa-arrows-v" aria-hidden="true"></i>
                    <div className="fafa-icon-myaccount">
                      <h6 className="font-weight-bold">Height</h6>
                      {userData.height}
                    </div>
                  </div>
                </div>
                <div className="col-md-4 col-6 mb-5">
                  <div className="fafa-icon-users">
                    <i className="fa fa-user mr-2-circle" aria-hidden="true"></i>
                    <div className="fafa-icon-myaccount">
                      <h6 className="font-weight-bold">Size</h6>
                      {userData.size}
                    </div>
                  </div>
                </div>
                <div className="col-md-4 col-6 mb-5">
                  <div className="fafa-icon-users">
                    <i className="fa fa-paint-brush" aria-hidden="true"></i>
                    <div className="fafa-icon-myaccount">
                      <h6 className="font-weight-bold">Body Shape Color</h6>
                      {userData.shape_color}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="edit-btn">
                <button
                  className="btn edit-info"
                  type="button"
                  onClick={() => setEditMode(true)}  // Toggle to edit mode when clicked
                >
                  Edit Personal Information
                </button>
            </div>

          </div> 


        )}
        </div>



      </div>
    </div>
  );
}

export default MyAccount;
